import { render, staticRenderFns } from "./SubstanceListSelectorModal.vue?vue&type=template&id=1ec368b4&"
import script from "./SubstanceListSelectorModal.vue?vue&type=script&lang=js&"
export * from "./SubstanceListSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports